import mitt from 'mitt';
import createDebug from '../utils/debug';
import type { IEventBus } from '@shore/types';

const eventBus = mitt<Record<string, unknown>>();
const eventDebugger = createDebug('event-bus');

export function createEventBus(): IEventBus {
  function getFilteredArgs(args: unknown[]) {
    return args.filter((arg) => typeof arg !== 'function');
  }

  function eventBusOn(...args: Parameters<IEventBus['on']>) {
    const filteredArgs = getFilteredArgs(args);
    eventDebugger('on', ...filteredArgs);
    eventBus.on(...args);
  }

  function eventBusOff(...args: Parameters<IEventBus['off']>) {
    const filteredArgs = getFilteredArgs(args);
    eventDebugger('off', ...filteredArgs);
    eventBus.off(...args);
  }

  function eventBusEmit(...args: Parameters<IEventBus['emit']>) {
    const filteredArgs = getFilteredArgs(args);
    eventDebugger('emit', ...filteredArgs);
    eventBus.emit(args[0], args[1]);
  }

  return Object.freeze({
    on: eventBusOn,
    off: eventBusOff,
    emit: eventBusEmit,
  });
}
